import { getCookieValue } from '@lingoda/cookie';
import type { KameleoonFeatureFlags, KameleoonFlagKey, KameleoonFlagValue } from './types';
import type { KameleoonVariationType } from '@kameleoon/react-sdk';

const variantValues: KameleoonFlagValue[] = ['on', 'variant'];
export const allowedFlagValues: KameleoonFlagValue[] = ['on', 'variant', 'off', 'control'];
export const isFlagEnabled = (value: KameleoonFlagValue): boolean => variantValues.includes(value);

const CONSENT_COOKIE_NAME = 'OptanonConsent';

export const shouldSetTrueKameleoonConsent = (): boolean => {
    const consentValue = getCookieValue(CONSENT_COOKIE_NAME);
    if (consentValue) {
        const groupsParam = consentValue.split('&').find((param) => param.startsWith('groups='));

        return !!groupsParam && groupsParam.includes('C0002:1');
    }

    return false;
};

export const parseFeaturesFromKameleoon = (
    activeFlags: Map<KameleoonFlagKey, KameleoonVariationType>,
) => {
    const newFeatures: KameleoonFeatureFlags = {};

    for (const [featureName, value] of activeFlags) {
        const flagValue = value.key as KameleoonFlagValue;

        newFeatures[featureName] = allowedFlagValues.includes(flagValue) ? flagValue : 'control';
    }

    return newFeatures;
};
